import React, { useEffect, useState, Fragment } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
export function UrgencyBar() {
  const [visible, setVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState(23 * 60 * 60 + 47 * 60 + 33);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  if (!visible) return null;
  const units = [{
    value: Math.floor(timeLeft / 3600),
    label: 'hs'
  }, {
    value: Math.floor(timeLeft % 3600 / 60),
    label: 'min'
  }, {
    value: timeLeft % 60,
    label: 'seg'
  }];
  return <motion.aside initial={reduceMotion ? false : {
    opacity: 0,
    y: -24
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: reduceMotion ? 0 : 0.35,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed inset-x-0 top-0 z-50 border-b border-white/15 bg-boxing-red px-3 py-2 text-white shadow-[0_5px_20px_rgba(217,25,32,0.32)]" aria-label="Oferta de lanzamiento" data-id="element-140">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-2" data-id="element-141">
        <div className="flex min-w-0 flex-1 flex-wrap items-center justify-center gap-2 sm:justify-start sm:gap-3" data-id="element-142">
          <p className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-wide sm:text-sm" data-id="element-143">
            <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-144" />
            <span data-id="element-145">Precio de lanzamiento expira en</span>
          </p>
          <div className="flex items-center gap-1 font-mono" aria-label={`Quedan ${units[0].value} horas, ${units[1].value} minutos y ${units[2].value} segundos`} data-id="element-146">
            {units.map((unit, index) => <Fragment key={unit.label} data-id="element-147">
                {index > 0 && <span className="pb-2 text-sm font-bold text-white/65" data-id="element-148">
                    :
                  </span>}
                <div className="min-w-[33px] rounded bg-black/20 px-1.5 py-0.5 text-center" data-id="element-149">
                  <span className="block text-sm font-black leading-none" data-id="element-150">
                    {String(unit.value).padStart(2, '0')}
                  </span>
                  <span className="mt-0.5 block text-[8px] font-bold uppercase tracking-wider text-white/70" data-id="element-151">
                    {unit.label}
                  </span>
                </div>
              </Fragment>)}
          </div>
          <span className="hidden text-xs font-semibold text-white/85 lg:inline" data-id="element-152">
            Después vuelve al precio normal.
          </span>
        </div>
        <button type="button" onClick={() => setVisible(false)} className="rounded p-1 text-white/75 transition-colors hover:bg-black/15 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Cerrar aviso de oferta" data-id="element-153">
          <XIcon className="h-4 w-4" data-id="element-154" />
        </button>
      </div>
    </motion.aside>;
}